import { Drawer, Grid, IconButton, useTheme, Typography } from '@mui/material'
import React from 'react'
import { CloseOutlined } from '@ant-design/icons'

const createStyles = (theme, width) => ({
  drawer: {
    '& .MuiDrawer-paper': {
      width,
      bgcolor: theme.palette.background.paper,
      backgroundImage: 'none',
    },
  },
  header: {
    bgcolor: theme.palette.background.paper,
  },
  title: {
    p: theme.spacing(2),
  },
  closeButton: {
    p: theme.spacing(1),
  },
})

export default function MBDrawer({
  title,
  open,
  onClose,
  children,
  disableCloseButton = false,
  width = '25%',
  headerSX = {},
  headerContainerSx = {},
  footer,
  footerContainerSx = {},
}) {
  const theme = useTheme()
  const styles = createStyles(theme, width)

  return (
    <Drawer anchor={'right'} open={open} onClose={onClose} sx={styles.drawer}>
      <Grid
        item
        container
        sx={title && { ...styles.header, ...headerContainerSx }}
        justifyContent={'space-between'}
      >
        <Grid item justifyContent={'flex-start'} sx={{ ...styles.title, ...headerSX }}>
          {title && <Typography variant={'h6'}>{title}</Typography>}
        </Grid>
        <Grid item justifyContent={'flex-end'} sx={styles.closeButton}>
          {!disableCloseButton && (
            <IconButton onClick={onClose}>
              <CloseOutlined />
            </IconButton>
          )}
        </Grid>
      </Grid>
      {children}
      {footer && (
        <Grid item sx={footerContainerSx}>
          {footer}
        </Grid>
      )}
    </Drawer>
  )
}
